"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.mapDispatchToProps = exports["default"] = exports.PortalDualListForAdministration = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _commonDualList = _interopRequireDefault(require("./common-dual-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var portalSelector = (0, _reselect.createSelector)(function (state) {
  return (0, _nicbaseReducers.getPortalsForBoxAdministration)(state);
}, function (portals) {
  return Object.values(portals).map(function (p) {
    return {
      id: p.id,
      label: p.name
    };
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    portals: portalSelector(state)
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    findPortalsForAssetAllocation: function findPortalsForAssetAllocation() {
      return dispatch((0, _nicbaseReducers.findPortalsForAssetAllocation)());
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var PortalDualListForAdministration = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PortalDualListForAdministration, _React$PureComponent);

  var _super = _createSuper(PortalDualListForAdministration);

  function PortalDualListForAdministration() {
    _classCallCheck(this, PortalDualListForAdministration);

    return _super.apply(this, arguments);
  }

  _createClass(PortalDualListForAdministration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.portals.length === 0) {
        this.props.findPortalsForAssetAllocation();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          portals = _this$props.portals,
          selectedPortals = _this$props.selectedPortals,
          allPortalsSelected = _this$props.allPortalsSelected,
          _onChange = _this$props.onChange;
      return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
        icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.PortalSelection, null),
        title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "duallist.portals",
          tagName: "span"
        })
      }, /*#__PURE__*/_react["default"].createElement(_commonDualList["default"], {
        items: portals,
        allItemsSelected: allPortalsSelected,
        selectedItems: selectedPortals,
        onChange: function onChange(_ref) {
          var allItemsSelected = _ref.allItemsSelected,
              selectedItems = _ref.selectedItems;
          return _onChange({
            allPortalsSelected: allItemsSelected,
            selectedPortals: selectedItems
          });
        }
      }));
    }
  }]);

  return PortalDualListForAdministration;
}(_react["default"].PureComponent);

exports.PortalDualListForAdministration = PortalDualListForAdministration;
PortalDualListForAdministration.propTypes = {
  allPortalsSelected: _propTypes["default"].bool,
  portals: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  selectedPortals: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func,
  findPortalsForAssetAllocation: _propTypes["default"].func
};
PortalDualListForAdministration.defaultProps = {
  allPortalsSelected: true,
  portals: [],
  selectedPortals: [],
  onChange: function onChange() {},
  findPortalsForAssetAllocation: function findPortalsForAssetAllocation() {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PortalDualListForAdministration);

exports["default"] = _default;